import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { filter } from 'rxjs';
import { POLAuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const userAgreementResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let authService = inject(POLAuthService);
  let hasUserDataInSession;
  const existingUserProfile = JSON.parse(inject(StorageService).getItem('user-profile'));
  authService.userAgreementLdFlag$.asObservable().subscribe((ldFlag) => {
    if (ldFlag) {
      hasUserDataInSession = existingUserProfile && existingUserProfile.useAgreement ? true : false;
    } else {
      hasUserDataInSession = existingUserProfile ? true : false;
    }
  });

  return authService.hasUserAgreementData$.asObservable().pipe(filter((res) => res.hasUserAgreementData || hasUserDataInSession));
};
